import { fork, take, call, put, all } from "redux-saga/effects";
import types from "./types";
import { postAPIWithoutModule } from "../../api/generic";
import { createSurveyFormResponse, fetchSurveyFormResponse, submitSurveyFormResponse } from "./action";

export function* doCreateSurveyForm() {
    while (true) {
        const { payload } = yield take(types.CREATE_SURVEY_FORM);
        const response = yield call(postAPIWithoutModule, payload);
        yield put(createSurveyFormResponse(response));
    }
}

export function* doFetchSurveyForm() {
    while (true) {
        const { payload } = yield take(types.FETCH_SURVEY_FORM);
        console.log(payload);
        const response = yield call(postAPIWithoutModule, payload);
        yield put(fetchSurveyFormResponse(response));
    }
}

export function* doSubmitSurveyForm() {
    while (true) {
        const { payload } = yield take(types.SUBMIT_SURVEY_FORM);
        console.log(payload);
        const response = yield call(postAPIWithoutModule, payload);
        yield put(submitSurveyFormResponse(response));
    }
}

function* search() {
    yield fork(doCreateSurveyForm);
    yield fork(doFetchSurveyForm);
    yield fork(doSubmitSurveyForm);
}

export default search;